import BlockGrid from './components/BlockGrid'
import { gutenplatzIcon } from './icon'

const api_key = document.getElementById('gutenplatzApiKey')
const wrapper = document.getElementById('gutenplatz')

if (api_key && api_key.value) {
  const data = JSON.parse(document.getElementById('gutenplatz-data').innerText)
  wp.element.render(
    wp.element.createElement(
      BlockGrid,
      {
        api_key: api_key.value,
        url: wrapper.getAttribute('data-server-url'),
        rest_url: wrapper.getAttribute('data-rest-url'),
        data: data
      }
    ),
    document.getElementById( 'gutenplatz-blocks' )
  );
}

( function() {
    if (wp.blocks) {
        wp.blocks.updateCategory( 'gutenplatz', { icon: gutenplatzIcon } );
    }
} )();


